import React, { useState, useEffect, useRef, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import FullCalendar from '@fullcalendar/react';
import frLocale from '@fullcalendar/core/locales/fr';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import api from '../services/api';
import { jwtDecode } from 'jwt-decode';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import './BookingCalendar.css';
import Modal from 'react-modal';
import API_URL from '../config';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import Hammer from 'hammerjs';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);




Modal.setAppElement('#root');

// Merging overlapping slots function
const mergeOverlappingSlots = (slots) => {
  if (!slots || slots.length === 0) return [];
  const groupedByDate = {};
  slots.forEach((slot) => {
    const date = format(new Date(slot.startTime), 'yyyy-MM-dd');
    if (!groupedByDate[date]) {
      groupedByDate[date] = [];
    }
    groupedByDate[date].push(slot);
  });

  const mergedSlots = [];
  Object.keys(groupedByDate).forEach((date) => {
    const slotsForDate = groupedByDate[date];
    slotsForDate.sort((a, b) => new Date(a.startTime) - new Date(b.startTime));

    let currentSlot = { ...slotsForDate[0] };
    for (let i = 1; i < slotsForDate.length; i++) {
      const nextSlot = slotsForDate[i];
      if (new Date(currentSlot.endTime) >= new Date(nextSlot.startTime)) {
        currentSlot.endTime = new Date(
          Math.max(new Date(currentSlot.endTime), new Date(nextSlot.endTime))
        ).toISOString();
      } else {
        mergedSlots.push(currentSlot);
        currentSlot = { ...nextSlot };
      }
    }
    mergedSlots.push(currentSlot);
  });

  return mergedSlots;
};

const BookingCalendar = () => {
	 const { user } = useContext(AuthContext); // Access the user context
  const calendarRef = useRef(null); // Reference to the calendar component
  const [errorMessage, setErrorMessage] = useState('');
  const [events, setEvents] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState('');
  const [rooms, setRooms] = useState([]);
  const [groupType, setGroupType] = useState('solo'); // Default is "solo"
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [mergedSlots, setMergedSlots] = useState([]);
  const [reservation, setReservation] = useState(null);
  const [message, setMessage] = useState('');
const [viewType, setViewType] = useState('timeGridWeek');   
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [newStartTime, setNewStartTime] = useState('');
  const [duration, setDuration] = useState(1);
  const [durationOptions, setDurationOptions] = useState([1]);  // Default to 1-hour duration option
  const [price, setPrice] = useState(0);
  const [unavailableSlotModal, setUnavailableSlotModal] = useState(false); // Modale pour créneau non disponible
  const [isRecap, setIsRecap] = useState(false); // Variable for controlling the dropdown visibility
  const [formattedDate, setFormattedDate] = useState('');
  
   const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  
 
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const roomFromUrl = searchParams.get('salle');

  const token = localStorage.getItem('token');

  const workStartTime = process.env.REACT_APP_WORK_START_TIME;
  const workEndTime = process.env.REACT_APP_WORK_END_TIME;

  const workStartHour = parseInt(process.env.REACT_APP_WORK_START_TIME.split(':')[0], 10);
  const workEndHour = parseInt(process.env.REACT_APP_WORK_END_TIME.split(':')[0], 10);

  const lastHour = workEndHour - 1;
  const hourOptions = Array.from({ length: lastHour - 8 + 1 }, (_, i) => `${(i + 8).toString().padStart(2, '0')}:00`);


  const handlePrev = () => {
    if (calendarRef.current) {
      calendarRef.current.getApi().prev();
    }
  };

  const handleNext = () => {
    if (calendarRef.current) {
      calendarRef.current.getApi().next();
    }
  };

  useEffect(() => {
    // Défiler vers le haut lorsque le composant est monté
    window.scrollTo(0, 0);
  }, [/* TODO: add missing deps */]);


  useEffect(() => {
    if (user) {
      const defaultView = user.role === 'view' ? 'timeGridDay' : 'timeGridWeek';
      setViewType(defaultView);
    }
  }, [user]);


  useEffect(() => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.changeView(viewType);
    }
  }, [viewType]);


  useEffect(() => {
     // Check if the calendar reference is set and has the necessary element
     if (calendarRef.current && calendarRef.current.el) {
		 
      const calendarElement = calendarRef.current.el;
       const hammer = new Hammer(calendarElement);

       // Adjust swipe settings for better responsiveness on mobile
       hammer.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });

       // Handle swipe gestures
       hammer.on('swipeleft', () => {
         calendarRef.current.getApi().next(); // Navigate to the next week
       });

       hammer.on('swiperight', () => {
         calendarRef.current.getApi().prev(); // Navigate to the previous week
       });

       // Cleanup HammerJS on component unmount
       return () => {
         hammer.off('swipeleft');
         hammer.off('swiperight');
         hammer.destroy();
       };
     }
   }, [/* TODO: add missing deps */]);
  
  
  useEffect(() => {
    if (selectedSlot && selectedSlot.startTime) {
	    const date = format(new Date(selectedSlot.startTime), 'EEEE d MMMM yyyy', { locale: fr });
	     setFormattedDate(date);
	 //    console.log("Date formatée mise à jour :", date);
		
		
     // console.log("calculateAvailableDurations appelé avec selectedSlot.startTime :", selectedSlot.startTime);
      calculateAvailableDurations();
    } else {
      //console.log("selectedSlot ou selectedSlot.startTime est indéfini. calculateAvailableDurations ne sera pas appelé.");
    }
  }, [selectedSlot, mergedSlots]);

  const calculateAvailableDurations = () => {
      const selectedSlotStartTime = new Date(selectedSlot.startTime);
      let maxDuration = Math.max(workEndHour - selectedSlotStartTime.getHours(), 0);

     // console.log("maxDuration au début de la fonction :", maxDuration);
     // console.log("selectedSlotStartTime :", selectedSlotStartTime);

      // Filtrer les événements pour ne garder que les réservations actives et futures par rapport à selectedSlotStartTime
      const reservationEvents = events
          .filter(event => event.status !== 'canceled' && event.title !== 'Libre' && new Date(event.start) > selectedSlotStartTime)
          .sort((a, b) => new Date(a.start) - new Date(b.start));

      //console.log("sortedEvents (réservations futures uniquement) :", reservationEvents);

      // Find the first future reservation and calculate available hours until it starts
      if (reservationEvents.length > 0) {
          const nextEventStart = new Date(reservationEvents[0].start);
          const availableHours = (nextEventStart - selectedSlotStartTime) / (1000 * 60 * 60);
        //  console.log("availableHours calculé :", availableHours);

          maxDuration = Math.min(maxDuration, Math.floor(availableHours));
      }

      // Calculate available hours until the end of work hours
      const workEnd = new Date(selectedSlotStartTime);
      workEnd.setHours(parseInt(workEndTime.split(':')[0], 10), 0, 0, 0);
      const availableBeforeWorkEnd = (workEnd - selectedSlotStartTime) / (1000 * 60 * 60);

      // console.log("workEnd défini à :", workEnd);
      // console.log("availableBeforeWorkEnd calculé à :", availableBeforeWorkEnd);

      maxDuration = Math.min(maxDuration, Math.floor(availableBeforeWorkEnd));

      // console.log("maxDuration après ajustements :", maxDuration);

      // Set duration options based on calculated max duration
      if (maxDuration <= 0) {
          setDurationOptions([]);
      } else {
          const availableDurations = Array.from({ length: Math.floor(maxDuration) }, (_, i) => i + 1);
          setDurationOptions(availableDurations);
      }

      // console.log("Options de durée disponibles calculées :", durationOptions);
  };

  const handleDateClick = (info) => {
    const clickedDate = new Date(info.date);
    const currentDate = new Date();

    clickedDate.setSeconds(0, 0);
    currentDate.setSeconds(0, 0);

    if (clickedDate < currentDate) {
      setMessage("Impossible de réserver dans le passé, choisir un créneau libre (en vert clair)");
      setUnavailableSlotModal(true);

      setTimeout(() => {
        setUnavailableSlotModal(false);
      }, 3000);
      return;
    }

    const availableSlot = mergedSlots.find((slot) => {
      const slotStart = new Date(slot.startTime);
      const slotEnd = new Date(slot.endTime);
      return slotStart <= clickedDate && slotEnd > clickedDate;
    });

    // console.log("Available Slot Found:", availableSlot);

    if (availableSlot) {
      // Set selectedSlot based on the exact clicked date and time
      setSelectedSlot({
        startTime: clickedDate, // Use the clicked date as startTime
        endTime: new Date(clickedDate.getTime() + 60 * 60 * 1000), // Default 1-hour duration
      });

    //  console.log("Selected Slot:", {
    //    startTime: clickedDate,
    //    endTime: new Date(clickedDate.getTime() + 60 * 60 * 1000),
    //  });

      setNewStartTime(format(clickedDate, 'HH:00'));
      setDuration(1);
      setIsConfirmModalOpen(true);
      calculatePrice();
    } else {
      setMessage("Créneau non disponible. Choisir un créneau disponible");
      setUnavailableSlotModal(true);

      setTimeout(() => {
        setUnavailableSlotModal(false);
      }, 3000);
    }
  };
  

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const response = await api.get(`${API_URL}/api/rooms`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setRooms(response.data);
        if (roomFromUrl) {
          const room = response.data.find((r) => r.name.toLowerCase() === roomFromUrl.toLowerCase());
          if (room) {
            setSelectedRoom(room._id);
          }
        } else {
          setSelectedRoom(response.data[0]?._id || '');
        }
      } catch (error) {
    //    console.error('Erreur lors du chargement des salles :', error);
        setMessage('Erreur lors du chargement des salles.');
      }
    };

    fetchRooms();
  }, [token, roomFromUrl]);
 
 
  useEffect(() => {
      if (calendarRef.current) {
        const calendarApi = calendarRef.current.getApi();
      
        // Check if the user role is 'client2' to set default view to 'timeGridDay'
        if (user && user.role === 'client2') {
          calendarApi.changeView('timeGridDay');
        } else {
          calendarApi.changeView('timeGridWeek');
        }
      }
    }, [user]);

  useEffect(() => {
    const fetchRoomData = async () => {
      if (!selectedRoom) return;

      try {
        const response = await api.get(
          `${API_URL}/api/rooms/${selectedRoom}/availability`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const merged = mergeOverlappingSlots(response.data);
        setMergedSlots(merged);

		const availableSlots = merged.map((slot) => {
		  let className = 'unavailable-slot'; // Default to unavailable

		  // Log the slot information to check its values
		//  console.log("Slot Data:", slot);

		 //   console.log("Slot is free:", slot); // Log when a slot is free
		    className = 'free-slot'; // Change to free if the slot is free
		  

		  return {
		    id: slot.id || Math.random().toString(36).substring(2, 15),
		    title: '',
		    start: slot.startTime,
		    end: slot.endTime,
		    classNames: [className], // Apply the class for color and style
		    display: 'background',
		    // Remove the color property to avoid conflicts with the class
		  };
		});
		
        setEvents(availableSlots);

        const bookingsResponse = await api.get(
          `${API_URL}/api/bookings/room/${selectedRoom}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const decodedToken = jwtDecode(token);
        const bookings = await Promise.all(
          bookingsResponse.data
            .filter((booking) => booking.status !== 'canceled')
            .map(async (booking) => {
              const isAdmin = decodedToken.role === 'admin';
              let userName = '';

              if (isAdmin && booking.userId) {
                const userResponse = await api.get(`${API_URL}/api/users/${booking.userId}`, {
                  headers: { Authorization: `Bearer ${token}` },
                });
                userName = userResponse.data.name;
              }

              const title = isAdmin
                ? `${userName ? `${userName}, ` : 'Inconnu, '}${booking.reservationNumber}`
                : booking.userId === decodedToken.id
                ? booking.status === 'confirmed' ? 'Ma réservation' : 'A payer dans onglet Réservation'
                : 'Autre réservation';

              return {
                id: booking.id,
                title,
                start: booking.startTime,
                end: booking.endTime,
                backgroundColor: booking.userId === decodedToken.id
                  ? booking.status === 'confirmed' ? '#006400' : '#FF0000'
                  : '#2196f3',
                borderColor: booking.userId === decodedToken.id
                  ? booking.status === 'confirmed' ? '#006400' : '#FF0000'
                  : '#2196f3',
                classNames: booking.userId === decodedToken.id
                  ? ['non-clickable-slot', 'user-reservation']
                  : ['non-clickable-slot'],
                extendedProps: { status: booking.status, userId: booking.userId },
              };
            })
        );

        setEvents((prevEvents) => [...prevEvents, ...bookings]);
      } catch (error) {
        setMessage('Erreur lors du chargement des réservations ou des créneaux bloqués.');
      }
    };

    fetchRoomData();
  }, [selectedRoom, token]);

  const calculatePrice = () => {
    const room = rooms.find((r) => r._id === selectedRoom);
    let hourlyRate = 0;

    if (room?.name === 'Grande') {
      hourlyRate = groupType === 'groupe'
        ? parseFloat(process.env.REACT_APP_PRICE_GRANDE_GROUPE)
        : parseFloat(process.env.REACT_APP_PRICE_GRANDE);
    } else if (room?.name === 'Petite') {
      hourlyRate = parseFloat(process.env.REACT_APP_PRICE_PETITE);
    }

    const totalPrice = duration * hourlyRate;
    setPrice(totalPrice);
  };

  useEffect(() => {
    calculatePrice();
  }, [duration, selectedRoom, groupType]);


  const handleReservation = async () => {
    if (!selectedSlot || !selectedRoom) {
      setMessage('Erreur : Créneau ou salle non sélectionné.');
      return;
    }

    const newEndTimeDate = new Date(selectedSlot.startTime);
    newEndTimeDate.setHours(newEndTimeDate.getHours() + duration);

    const soloOrGroupValue = groupType === 'groupe' ? 'Group' : 'solo';

    try {
	  const decodedToken = jwtDecode(token);
      const response = await axios.post(
        `${API_URL}/api/bookings`,
        {
          roomId: selectedRoom,
          userId: decodedToken.id,
          startTime: selectedSlot.startTime.toISOString(),
          endTime: newEndTimeDate.toISOString(),
          soloOrGroup: soloOrGroupValue,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setReservation(response.data);
      setIsConfirmModalOpen(false);
      setIsRecap(true);
      setMessage('Réservation effectuée avec succès !');
    } catch (error) {
      setErrorMessage("Réservation impossible");
   // Masquer le message d'erreur et fermer la modale après 1,5 seconde, puis recharger la page
      setTimeout(() => {
        setErrorMessage('');
        setIsConfirmModalOpen(false);
        window.location.reload(); // Recharge la page pour mettre à jour le calendrier
      }, 1500);
    }
  };



  const handleRoomChange = (e) => {
    setSelectedRoom(e.target.value);
    setEvents([]);
  };

  const getRoomDisplayName = (name, soloOrGroup) => {
    if (name === 'Grande') {
      return `Grande salle (${groupType === 'groupe' ? 'en groupe' : 'en solo'})`;
    } else if (name === 'Petite') {
      return 'Petite salle';
    } else {
      return name;
    }
  };

  const handleCancel = async () => {
    if (!reservation) return;

    try {
      await axios.patch(`${API_URL}/api/bookings/${reservation._id}/cancel`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setReservation(null);
	  setIsRecap(false); 
      setMessage('Réservation annulée avec succès.');
    } catch (error) {
      setMessage("Erreur lors de l'annulation de la réservation.");
    }
  };

  // Ensure you initialize navigate at the top of your component
  const navigate = useNavigate();


  // Fonction FakePayment with logging
  const FakePayment = async () => {
    console.log("Starting FakePayment function");

    if (!reservation || !reservation._id) {
      console.log("No reservation or reservation ID found");
      setMessage("Erreur : aucune réservation sélectionnée.");
      return;
    }

    try {
      const token = localStorage.getItem('token');
      console.log("Token retrieved:", token);
      console.log("Reservation ID:", reservation._id);

      // Attempting to confirm the reservation via API
      const response = await axios.patch(`${API_URL}/api/bookings/${reservation._id}/confirm`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("Reservation confirmed, response:", response.data);

      // Redirecting to the payment success page with reservation number
      console.log(`Redirecting to /payment-success?reservationNumber=${reservation._id}`);
      navigate(`/success-payment?bookingId=${reservation._id}`);
    } catch (error) {
      console.error("Error during reservation confirmation:", error);
      setMessage("Erreur lors de la confirmation de la réservation. Veuillez réessayer.");
    }
  };

  


  const handlePayment = async () => {
    try {
      const stripe = await stripePromise;

      const room = rooms.find((r) => r._id === selectedRoom);
      const productData = getRoomDisplayName(room?.name, groupType);

      const response = await axios.post(`${API_URL}/api/payments`, {
        amount: price * 100, 
        currency: 'eur',
        bookingId: reservation._id,
        productData 
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const { id } = response.data;
      const { error } = await stripe.redirectToCheckout({ sessionId: id });

      if (error) {
        setMessage('Erreur lors du paiement.');
      }
    } catch (error) {
      setMessage("Erreur lors de la création de la session de paiement.");
    }
  };

  const mapRoomName = (roomName) => {
    if (roomName === 'Grande') return 'Grande Salle';
    if (roomName === 'Petite') return 'Petite Salle';
    return roomName;
  };


  const handleConfirmModalClose = () => {
    setIsConfirmModalOpen(false);
    setSelectedSlot(null);
  };

  return (
    <div className="calendar-container">

  
	  {!isRecap && (
	     <p style={{ fontStyle: 'italic', marginBottom: '10px', fontWeight: 'bold', fontSize: '1em' }}>
	       Pour réserver, cliquer sur un créneau libre (en vert)
	     </p>
	   )}
  
  	  {unavailableSlotModal && (
	      <Modal
	          isOpen={unavailableSlotModal}
	          className="error-modal"
	          overlayClassName="error-overlay"
	      >
	          <p>{message}</p>
	      </Modal>
	  )}

      {!isRecap && (
        <select
          className="room-select"
          value={selectedRoom}
          onChange={handleRoomChange}
        >
          <option value="">-- Sélectionner une salle --</option>
          {rooms.map((room) => (
            <option key={room._id} value={room._id} style={{ fontWeight: 'bold' }}>
              {mapRoomName(room.name)}
            </option>
          ))}
        </select>
      )}

      {!reservation ? (
        <>
          <FullCalendar
		  ref={calendarRef} 
            plugins={[timeGridPlugin, interactionPlugin]}
            initialView={viewType} 
            locale={frLocale}
            nowIndicator={true}
            events={events}
		    validRange={{
		      start: (() => {
		        const now = new Date();
		        const todayMidnight = new Date();
		        todayMidnight.setHours(0, 0, 0, 0);
      
		        // Si la date est aujourd'hui, commence à l'heure actuelle, sinon commence à minuit
		        if (now.toDateString() === todayMidnight.toDateString()) {
		          return now;
		        }
		        return todayMidnight;
		      })(),
		    }}
		    datesSet={(arg) => {
		       // Format the start date of the week
		       const startDate = format(new Date(arg.start), "'Semaine du' d MMMM yyyy", { locale: fr });
		       // Set the formatted title manually
		   //    document.querySelector('.fc-toolbar-title').textContent = startDate;
		     }}
            eventClick={(info) => {
              const clickedEvent = info.event;
              const booking = events.find(e => String(e.id) === String(clickedEvent.id));
              if (booking && booking.extendedProps.status === 'pending' && booking.extendedProps.userId === jwtDecode(token).id) {
                   setReservation({
                  ...booking,
                  startTime: booking.start,
                  endTime: booking.end,
                  status: booking.extendedProps.status,
                });
                setIsRecap(true);
              }
            }}
            dateClick={handleDateClick}
		    selectable={true} // Active la sélection par clic
		     
            slotDuration="01:00:00"
            snapDuration="01:00:00"
            slotLabelInterval="01:00"
            slotLabelFormat={{ hour: '2-digit', minute: '2-digit', hour12: false }}
            slotMinTime={workStartTime}
            slotMaxTime={workEndTime}
            headerToolbar={{
              left:'' ,
              center: 'title',
              right: 'prev,next',
            }}
            timeZone="local"
            allDaySlot={false}
            height="auto"
            expandRows={true}
            contentHeight="auto"
            dayMaxEventRows={true}
            moreLinkClick="popover"
            navLinks={true}
         
          />
		  <Modal
		    isOpen={isConfirmModalOpen}
		    onRequestClose={handleConfirmModalClose}
		    className="modal"
		    overlayClassName="overlay"
		  >
		    <h3>Sélection du créneau</h3>

		    {/* Logging to verify rendering */}
	
		    <form>
		      <div className="form-group-vertical-center">
		        <div>
	
				   <label>Date : </label>
		          <span>{formattedDate}</span> 
		        </div>
		      </div>
		      <hr />

		      <div className="form-group-horizontal">
		        <div>
		          <label>Heure de début :</label>
		          <select
		            className="styled-select"
		            value={newStartTime}
		            onChange={(e) => {
		              const time = e.target.value;
		              setNewStartTime(time);
		              const [hour] = time.split(':').map(Number);
		              const updatedStartTime = new Date(selectedSlot.startTime);
		              updatedStartTime.setHours(hour, 0, 0, 0);
		              setSelectedSlot((prev) => ({
		                ...prev,
		                startTime: updatedStartTime,
		              }));
		            }}
		            required
		          >
		            {hourOptions.map((time) => (
		              <option key={time} value={time}>
		                {time}
		              </option>
		            ))}
		          </select>
		        </div>

		        <div>
		          <label>Durée :</label>
		          <select
		            value={duration}
		            onChange={(e) => setDuration(Number(e.target.value))}
		          >
		            {durationOptions.map((hour) => (
		              <option key={hour} value={hour}>
		                {hour}
		              </option>
		            ))}
		          </select>
		        </div>
		      </div>

		      {rooms.find((r) => r._id === selectedRoom)?.name === 'Grande' && (
		        <div className="form-group-horizontal">
		          <label>Type :</label>
		          <select
		            value={groupType}
		            onChange={(e) => setGroupType(e.target.value)}
		          >
		            <option value="solo">Solo (une personne)</option>
		            <option value="groupe">Groupe</option>
		          </select>
		        </div>
		      )}

		      <div className="form-group-horizontal">
		        <label>Prix total :</label>
		        <span className="price">{price}€</span>
		      </div>
		    </form>

		    {errorMessage && (
		      <div className="error-message">
		        {errorMessage}
		      </div>
		    )}

		    <button className="confirm-button" onClick={handleReservation}>
		      Sélectionner
		    </button>
		    <button className="cancel-button" onClick={handleConfirmModalClose}>
		      Annuler
		    </button>
		  </Modal>
        </>
      ) : (
        <div>
          <h3>Récapitulatif de la réservation</h3>
          <p><strong>Salle :</strong> {getRoomDisplayName(rooms.find(room => room._id === selectedRoom)?.name, groupType)}</p>
          <p><strong>Date :</strong> {format(new Date(reservation.startTime), 'EEEE d MMMM yyyy', { locale: fr })}</p>
          <p><strong>Heure de début :</strong> {format(new Date(reservation.startTime), 'HH:mm')}</p>
          <p><strong>Heure de fin :</strong> {format(new Date(reservation.endTime), 'HH:mm')}</p>
          <p><strong>Prix total :</strong> {price} €</p>
          <div className="button-container">
            <button className="pay-button"   onClick={user.role === 'admin' ? FakePayment : handlePayment}>Payer</button>		  
            <button className="cancel-button" onClick={handleCancel}>Annuler</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingCalendar;